const $ = window.jQuery;

const ReadMoreFade = {
    init() {
        // Define the screen width breakpoint (e.g., 768px for mobile & tablets)
        const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;

        // Only run if the screen size is small
        if (isSmallScreen) {
            $(".fade_text").each(function (index) {
                let $container = $(this);
                let $paragraphs = $container.find("p:not(.read-more)");

                // Check if more than 2 paragraphs exist
                if ($paragraphs.length > 2) {
                    // Hide paragraphs except the first two
                    $paragraphs.slice(2).hide();

                    // Create a unique ID for the hidden content
                    let contentId = "readmore-content-" + index;
                    $paragraphs.slice(2).attr("id", contentId);

                    // Add the "Read More" button with accessibility attributes
                    let readMoreBtn = $(`
                        <p class="read-more">
                            <button 
                                class="btn btn-danger" 
                                aria-expanded="false" 
                                aria-controls="${contentId}">
                                LÄS MER
                            </button>
                        </p>
                    `);
                    $container.append(readMoreBtn);

                    let $button = readMoreBtn.find("button");

                    // Handle click and keyboard events
                    $button.on("click keydown", function (e) {
                        if (e.type === "click" || (e.type === "keydown" && (e.key === "Enter" || e.key === " "))) {
                            e.preventDefault(); // Prevent default anchor jump

                            let isExpanded = $container.hasClass("expanded");

                            if (isExpanded) {
                                // Collapse: Hide paragraphs after the first two
                                $paragraphs.slice(2).slideUp(300);
                                $container.removeClass("expanded");
                                $(this).attr("aria-expanded", "false").text("LÄS MER");
                            } else {
                                // Expand: Show all paragraphs
                                $paragraphs.slideDown(300);
                                $container.addClass("expanded");
                                $(this).attr("aria-expanded", "true").text("VISA MINDRE");
                            }
                        }
                    });
                }
            });
        }
    },
};

// Auto-initialize when script loads
jQuery(document).ready(function () {
    ReadMoreFade.init();
});

export default ReadMoreFade;
